import React from 'react';
import { Chip, Box, Typography, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import format from 'date-fns/format';

const ClubPaymentStatusChip = ({ id, label, expiresAt, paid }) => {
    const chipStyles = {
        fontWeight: 'bold',
        fontSize: '0.875rem',
        px: 2,
        py: 1.2,
        borderRadius: 3,
        color: '#fff',
        mb: 0.5
    };

    let formattedDate = null;
    try {
        formattedDate = format(new Date(expiresAt), 'yyyy-MM-dd');
    } catch (e) {
        formattedDate = expiresAt;
    }

    return (
        // <Box key={id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 1 }}>
        //     <Chip
        //         icon={
        //             paid ? (
        //                 <CheckCircleIcon color="#fefefe" sx={{ color: '#ffffff' }} />
        //             ) : (
        //                 <HourglassBottomIcon color="#fefefe" sx={{ color: '#ffffff' }} />
        //             )
        //         }
        //         label={`${label} — ${paid ? 'Active' : 'Pending Payment'}`}
        //         sx={{
        //             ...chipStyles,
        //             bgcolor: paid ? '#2E7D32' : '#FB8C00'
        //         }}
        //     />
        //     {expiresAt && (
        //         <Typography variant="caption" sx={{ color: paid ? '#2E7D32' : '#FB8C00', ml: 1 }}>
        //             Expires at: {formattedDate}
        //         </Typography>
        //     )}
        // </Box>
        <Grid container spacing={2} alignItems="center" key={id} sx={{ mb: 1 }}>
            <Grid item xs={4}>
                <Typography variant="body1" fontWeight="bold">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={4}>
                {expiresAt && (
                    <Typography variant="body2" color="textSecondary">
                        Expires at: {formattedDate}
                    </Typography>
                )}
            </Grid>
            <Grid item xs={4}>
                <Chip
                    icon={
                        paid ? (
                            <CheckCircleIcon color="#fefefe" sx={{ color: '#ffffff' }} />
                        ) : (
                            <HourglassBottomIcon color="#fefefe" sx={{ color: '#ffffff' }} />
                        )
                    }
                    label={paid ? 'Active' : 'Pending Payment'}
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '0.875rem',
                        px: 2,
                        py: 1.2,
                        borderRadius: 3,
                        color: '#fff',
                        bgcolor: paid ? '#2E7D32' : '#FB8C00'
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default ClubPaymentStatusChip;
